export const CONTR_OBLIGATIONS_LIST = 'CONTR_OBLIGATIONS_LIST';
export const ADD_OBLIGATION_SUCCESS = 'ADD_OBLIGATION_SUCCESS';
export const EDIT_OBLIGATION_SUCCESS = 'EDIT_OBLIGATION_SUCCESS';
export const OBLIGATION_CRUD = 'OBLIGATION_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
export const OBLIGATIONS_LOADER = 'OBLIGATIONS_LOADER';
export const GET_APPROVED_BY_USER = "GET_APPROVED_BY_USER";
